module.exports = __webpack_public_path__ + "img/EKWATEUR.077ba01d.png";